
module.exports = {
	AUTH_LOGIN_REQUEST: "AUTH_LOGIN_REQUEST",
	AUTH_LOGIN_SUCCESS: "AUTH_LOGIN_SUCCESS",
	AUTH_LOGIN_FAILURE: "AUTH_LOGIN_FAILURE",
    CLEAR_LOGIN_ERROR: "CLEAR_LOGIN_ERROR",
    SET_LOGIN_REDIRECT_URL: "SET_LOGIN_REDIRECT_URL",
    CLEAR_LOGIN_REDIRECT_URL: "CLEAR_LOGIN_REDIRECT_URL",
	AUTH_LOGOUT_SUCCESS: "AUTH_LOGOUT_SUCCESS",
    AUTH_REGISTER_SUCCESS: "AUTH_REGISTER_SUCCESS",
	AUTH_REGISTER_ERROR: "AUTH_REGISTER_ERROR",
	CLEAR_REGISTER_ERROR: "CLEAR_REGISTER_ERROR",
    AUTH_FACEBOOK_REQUEST: "AUTH_FACEBOOK_REQUEST",
    AUTH_FACEBOOK_SUCCESS: "AUTH_FACEBOOK_SUCCESS",
    AUTH_FACEBOOK_FAILURE: "AUTH_FACEBOOK_FAILURE",
	REQUEST_CURRENT_USER: "REQUEST_CURRENT_USER",
	RECEIVE_CURRENT_USER: "RECEIVE_CURRENT_USER",
	REQUEST_CURRENT_USER_ERROR: "REQUEST_CURRENT_USER_ERROR",
    AUTH_LOGOUT: "AUTH_LOGOUT",
    AUTH_REFRESH_TOKEN_REQUEST: "AUTH_REFRESH_TOKEN_REQUEST",
    AUTH_REFRESH_TOKEN_FAILURE: "AUTH_REFRESH_TOKEN_FAILURE",
    STORE_EXTERNAL_ID_SUCCESS: "STORE_EXTERNAL_ID_SUCCESS"
};



// WEBPACK FOOTER //
// ./src/common/modules/auth/constants.js